import { render, staticRenderFns } from "./ProvinsiContent.vue?vue&type=template&id=ed8c1352&scoped=true"
import script from "./ProvinsiContent.vue?vue&type=script&lang=js"
export * from "./ProvinsiContent.vue?vue&type=script&lang=js"
import style0 from "./ProvinsiContent.vue?vue&type=style&index=0&id=ed8c1352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8c1352",
  null
  
)

export default component.exports